if (!customElements.get('client-care')) {
  customElements.define('client-care', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const search = this.querySelector('[data-care-search]');
      const input = this.querySelector('.client-care__search-input');
      const clear = this.querySelector('.client-care__clear');
      const status = this.querySelector('.client-care__status');
      const empty = this.querySelector('.client-care__empty');
      const groups = [...this.querySelectorAll('[data-care-group]')];
      const rows = [...this.querySelectorAll('[data-care-question]')];
      if (!search || !input) return;
      const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
      const searchable = new Map(rows.map(row => [row, normalize(row.textContent)]));
      let previousState = null;
      const filter = () => {
        const terms = normalize(input.value).split(' ').filter(Boolean);
        if (terms.length && !previousState) previousState = new Map(rows.map(row => [row, row.open]));
        let count = 0;
        rows.forEach(row => {
          const matches = terms.every(term => searchable.get(row).includes(term));
          row.hidden = !matches;
          if (terms.length) row.open = matches;
          else if (previousState) row.open = previousState.get(row);
          if (matches) count++;
        });
        groups.forEach(group => { group.hidden = ![...group.querySelectorAll('[data-care-question]')].some(row => !row.hidden); });
        empty.hidden = count > 0;
        clear.hidden = !input.value;
        status.textContent = terms.length ? `${count} ${count === 1 ? 'answer' : 'answers'} found` : '';
        if (!terms.length) previousState = null;
      };
      input.addEventListener('input', filter, { signal });
      clear.addEventListener('click', () => { input.value = ''; filter(); input.focus(); }, { signal });
      input.addEventListener('keydown', event => {
        if (event.key === 'Escape' && input.value) { input.value = ''; filter(); }
      }, { signal });
      this.querySelectorAll('.client-care__topic').forEach(link => {
        link.addEventListener('click', () => { input.value = ''; filter(); }, { signal });
      });
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        input.value = ''; filter();
        const row = event.target.closest('[data-care-question]');
        if (row) row.open = true;
      }, { signal });
      search.hidden = false;
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
